import React from "react";
import { Box } from "@mui/material";
import SideNav from "../../../components/commonComponents/Sidebar/SideNav";
import {
    StyledMainBox,
    StickyTopRowStackSpaceBetween,
} from "../../../components/commonComponents/StyledComponents/styled";
import { checkUserDetailsFromCookie } from "../../../api_calls/userManagement";
import Grid from "@mui/material/Unstable_Grid2";

import { TextButton } from "../../../components/commonComponents/Buttons/ActionButton";
import { useNavigate, useParams } from "react-router-dom";

import Dashboard from "../../../components/commonComponents/Embeddable/Dashboard";
import AccessControl from "../../../components/commonComponents/Hoc/AccessControl";

const DataSanity = () => {
    // Variables
    const [userInfo, setUserInfo] = React.useState({});
    const { id } = useParams();
    const navigate = useNavigate();

    const dashboardVariables = () => {
        let overviewDashboardVariables = {
            IdCampaign: id,
        }

        // if (typeof userStateDate.embedded_clip_overview_clip_selection !== "undefined" && userStateDate.embedded_clip_overview_clip_selection.length !== 0) {
        //     overviewDashboardVariables = {
        //         ...overviewDashboardVariables,
        //         IdClip: userStateDate.embedded_clip_overview_clip_selection,
        //     }
        // }
        // if (typeof userStateDate.embedded_clip_overview_stores !== "undefined" && userStateDate.embedded_clip_overview_stores.store_ids.length !== 0) {
        //     overviewDashboardVariables = {
        //         ...overviewDashboardVariables,
        //         Stores: userStateDate.embedded_clip_overview_stores.store_ids,
        //     }
        // }

        return overviewDashboardVariables;
    }

    React.useEffect(() => {
        const checkUserDetails = checkUserDetailsFromCookie();

        let userDetailObj = {};
        if (checkUserDetails.success === true) {
            userDetailObj = checkUserDetails.user_detail;
        }
        setUserInfo(userDetailObj);
    }, []);

    // Elements
    return (
        <StyledMainBox component="main">
            <StickyTopRowStackSpaceBetween direction={"row"} spacing={2}>
                {/* ------- Back to campaigns button ----------- */}
                <Box sx={{ alignContent: "center" }}>
                    <TextButton
                        onClick={(e) => {
                            // e.preventDefault();
                            navigate("/check-campaigns/list");
                        }}
                        label={"Back to Contact-based Campaigns"}
                    />
                </Box>

            </StickyTopRowStackSpaceBetween>
            <Box height={1} />
            <Grid container spacing={2}>
                {typeof userInfo.root_company_id !== "undefined" && userInfo.root_company_id !== "" && (
                    <Dashboard
                        embedDashboardId={"5003a4c3-fd6b-4669-b423-ae1aa8f37bb9"}
                        variables={dashboardVariables()}
                        filterConfig={{
                            "number_root": userInfo.root_company_id.toString(),
                        }} />
                )}
            </Grid>
        </StyledMainBox>
    );
};
// export default DataSanity;
export default AccessControl(DataSanity, ["campaign_reports_internal_settings_can_view"], [], ["campaigns_section", "campaign_list"]);
